import { createContext } from 'react';
import { BillingMode } from '../../constants';

interface DialogManipulationContextProps {
    open(this: void): void;
    close(this: void): void;
}

export const DialogFunctionsContext = createContext<DialogManipulationContextProps>({
    open: () => {},
    close: () => {},
});

interface AssociateCurrentOwnerContextProps {
    associateCurrentOwner: boolean;
    toggleAssociateCurrentOwner: (newVal: boolean) => void;
}
export const AssociateCurrentOwnerContext = createContext<AssociateCurrentOwnerContextProps | null>(null);

interface SelectedAccountIdsContextProps {
    selectedAccountId: string;
    setSelectedAccountId: (accountId: string) => void;
    billingOwnerId: string;
}

export const SelectedAccountIdsContext = createContext<SelectedAccountIdsContextProps | null>(null);

export const BillingModeContext = createContext<BillingMode>(BillingMode.AccountBilling);
